import { isAddress, encodeFunctionData, encodeAbiParameters } from 'viem';
import { modularAccountAbi } from '../lib/permissionless/accounts/modular/abis/modularAccountAbi';
// Minimal ABI for executionManifest() - ERC-6900 IExecutionModule
const IExecutionModuleABI = [
    {
        name: 'executionManifest',
        type: 'function',
        inputs: [],
        outputs: [
            {
                name: '',
                type: 'tuple',
                components: [
                    {
                        name: 'executionFunctions',
                        type: 'tuple[]',
                        components: [
                            { name: 'executionSelector', type: 'bytes4' },
                            { name: 'skipRuntimeValidation', type: 'bool' },
                            { name: 'allowGlobalValidation', type: 'bool' },
                        ],
                    },
                    {
                        name: 'executionHooks',
                        type: 'tuple[]',
                        components: [
                            { name: 'executionSelector', type: 'bytes4' },
                            { name: 'entityId', type: 'uint32' },
                            { name: 'isPreHook', type: 'bool' },
                            { name: 'isPostHook', type: 'bool' },
                        ],
                    },
                    { name: 'interfaceIds', type: 'bytes4[]' },
                ],
            },
        ],
        stateMutability: 'pure',
    },
];
export async function installAccountModules(args) {
    const { smartAccount, signer, accountModulesAddress } = args;
    if (!isAddress(accountModulesAddress)) {
        throw new Error('Invalid accountModulesAddress');
    }
    const encodedInstallationData = await encodeAccountModulesInstallation({
        smartAccount,
        accountModulesAddress,
    });
    // IMPORTANT: Must use executeBatch (arrays) for self-calls, not execute
    return smartAccount.sendUserOp({
        toAddress: [smartAccount.address],
        callData: [encodedInstallationData],
        functionHashForPaymasterProxy: 'installAccountModules',
        spaceId: undefined,
        signer,
        skipConfirmation: true,
    });
}
export async function encodeAccountModulesInstallation(args) {
    const { smartAccount, accountModulesAddress } = args;
    const manifest = (await smartAccount.publicRpcClient.readContract({
        address: accountModulesAddress,
        abi: IExecutionModuleABI,
        functionName: 'executionManifest',
    }));
    const moduleInstallData = encodeAbiParameters([{ type: 'address' }], [smartAccount.address]);
    const encodedInstallationData = encodeFunctionData({
        abi: modularAccountAbi,
        functionName: 'installExecution',
        args: [accountModulesAddress, manifest, moduleInstallData],
    });
    return encodedInstallationData;
}
